const JS = {
  formatarData(date) {
    if (date == null) return '';
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('/');
  },
  calcularTempoDeCasa(dateAdm) {
    const dataHoje = new Date();
    const dataAdm = new Date(dateAdm);
    const diferenca = dataHoje - dataAdm;

    const diferencaEmDias = diferenca / 1000 / 60 / 60 / 24;
    const horasRestantes = (diferenca / 1000 / 60 / 60) % 24;

    return (diferencaEmDias + horasRestantes / 24) / 365;
  },
  isCollapsed(tipo) {
    return this.tiposQuestaoCollapsed.includes(tipo);
  },
  expand(tipoQuestao) {
    if (this.isCollapsed(tipoQuestao))
      this.tiposQuestaoCollapsed = this.tiposQuestaoCollapsed.filter(item => item !== tipoQuestao);
    else this.tiposQuestaoCollapsed.push(tipoQuestao);
  },
  createFileFromBase64(nomeAnexo, anexo) {
    const base64Data = anexo.includes('base64,') ? anexo.split('base64,')[1] : anexo;
    const binaryString = atob(base64Data);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);

    const extension = nomeAnexo.split('.').pop().toLowerCase();
    let mimeType = 'application/octet-stream';

    const mimeTypes = {
      pdf: 'application/pdf',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      txt: 'text/plain',
    };

    if (extension in mimeTypes) mimeType = mimeTypes[extension];

    const blob = new Blob([bytes], { type: mimeType });

    return new File([blob], nomeAnexo, { type: mimeType });
  },
};

export default JS;
